// extracted by mini-css-extract-plugin
export default {"content-alarm":"AlarmDetailPopup_content-alarm__cBWrT","box-template":"AlarmDetailPopup_box-template__g-YQe","border":"AlarmDetailPopup_border__GqKmp"};